import React, { Component } from 'react';
import List from './List';
import Form from './Form';
import TabbablePage from '../../components/TabbablePage';
import DocumentTitle from 'react-document-title';
import RouteComponent from '../../components/RouteComponent';

export default class Page extends RouteComponent {
	render() {
		return (
			<DocumentTitle title="Kontrolní body">
				<TabbablePage
					module="checkpoint"
					List={List}
					Form={Form}
					newTitle="Nový"
					listTitle="Seznam kontrolních bodů"
					{...this.props}
				/>
			</DocumentTitle>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/Checkpoint/Page.js